export const baseUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;

export const getUrlParam = (param: string): string | null => {
  const url = new URL(window.location.href);
  return new URLSearchParams(url.search).get(param);
};

// On native Capacitor builds the bundle is served from capacitor://localhost (iOS) or
// http://localhost (Android) — neither has an API server. Prepend the absolute API host
// so relative-looking paths actually reach the backend.
// NOTE: window.Capacitor exists in web mode too; isNativePlatform() is the correct gate.
const isNative =
  typeof window !== 'undefined' && (window as unknown as { Capacitor?: { isNativePlatform?(): boolean } }).Capacitor?.isNativePlatform?.() === true;
const apiHost =
  process.env.VITE_API_HOST ||
  (process.env.NODE_ENV === 'production' ? 'https://home.palmetto.com' : 'https://home-next.palmetto.com');

const webApiHost = process.env.NODE_ENV === 'production' ? apiHost : '';

export const apiBase = (version: `v${number}`) => `${isNative ? apiHost : webApiHost}/api/${version}`;
